'use strict';

/**
 * DO NOT MODIFY
 * Generated from yarn nx run illustrations:sync
 */

/**
 * Currently used on web for interpolating the URL to CDN hosted asset using the name and version number.
 *
 * For example, given the following Pictogram versionMap, '{ someIllustration: 2 }', and
 * JSX such as '<Pictogram name="someIllustration />' will result in an image with the following URL:
 *
 * 'https://static-assets.coinbase.com/design-system/illustrations/pictogram/light/someIllustration-2.svg
 *
 * In addition, this file is used to populate Pictogram stories in percy, so the sort order based on createdAt is important.
 */
const versionMap = {
  fiat: 2,
  musicAndSounds: 2,
  custodyNavigation: 3,
  globalPayments: 3,
  moneySwift: 2,
  decentralizedExchange: 3,
  trendingAssets: 3,
  globalTransactions: 4,
  orders: 1,
  emailAndMessages: 2,
  smsAuthenticate: 2,
  earnGraph: 3,
  helpCenterNavigation: 3,
  globalConnections: 3,
  add: 2,
  videoContent: 3,
  error: 2,
  decentralizedWeb3: 3,
  feesRestriction: 3,
  lowFees: 2,
  delegate: 2,
  coinbaseOneShield: 2,
  calendar: 2,
  rewardsNavigation: 3,
  laptop: 2,
  coinbaseOneLogo: 3,
  listingFees: 3,
  payNavigation: 3,
  browserTransaction: 2,
  borrowCoins: 2,
  enableVoting: 2,
  newUserChecklistBuyCrypto: 2,
  applyForHigherLimits: 2,
  tryAgainLater: 2,
  selfCustodyWallet: 3,
  walletDeposit: 2,
  coinbaseWalletApp: 2,
  taxBeta: 2,
  mobileNotifcation: 2,
  agent: 3,
  exchangeNavigation: 4,
  investGraph: 3,
  strongInfo: 2,
  easyToUse: 2,
  usaProduct: 2,
  laptopCharts: 2,
  cryptoFolder: 2,
  completeQuiz: 3,
  cardNavigation: 3,
  taxes: 3,
  pieChart: 2,
  taxCenterNavigation: 4,
  newUserChecklistVerifyId: 2,
  rosettaNavigation: 3,
  authenticatorProgress: 2,
  nftNavigation: 3,
  protectionPlan: 2,
  addCard: 2,
  moneyEarn: 2,
  sellSendAnytime: 2,
  videoCalendar: 3,
  coinbaseOneRefreshed: 3,
  addPayment: 2,
  addWallet: 2,
  safe: 2,
  identityCard: 2,
  collectionOfAssets: 2,
  seedPhrase: 2,
  queryTransactNavigation: 3,
  trading: 1,
  ubiKey: 2,
  browser: 2,
  multiPlatform: 2,
  decentralizationEverything: 3,
  coldStorageCheck: 2,
  chart: 1,
  bundle: 2,
  waiting: 2,
  locationUsa: 3,
  monitoringPerformance: 3,
  transferSend: 2,
  giftbox: 3,
  blockchainConnection: 3,
  strongWarning: 2,
  controlWalletStorage: 3,
  bitcoinPizza: 2,
  settled: 2,
  takeQuiz: 2,
  commerceNavigation: 3,
  institutionalNavigation: 3,
  linkYourAccount: 2,
  receipt: 2,
  sideChainSide: 2,
  governance: 2,
  ethereumFocus: 3,
  coinShare: 2,
  multipleAssets: 2,
  coinbaseOneEarnCoins: 2,
  taxesArrangement: 2,
  authenticatorAlt: 2,
  mobileCharts: 2,
  lock: 2,
  walletExchange: 2,
  explore: 3,
  cardBlocked: 2,
  signInNavigation: 3,
  borrowNavigation: 3,
  institutions: 2,
  connectNavigation: 3,
  pluginBrowser: 3,
  venturesNavigation: 2,
  taxSeason: 2,
  noVisibility: 2,
  assetMovement: 3,
  partialCoins: 2,
  primeNavigation: 3,
  worldwide: 2,
  layerNetworks: 3,
  paypal: 2,
  multiAccountsAndCards: 3,
  warning: 2,
  decentralizedIdentity: 2,
  target: 3,
  selfServe: 2,
  assetEncryption: 3,
  noNftFound: 2,
  holdingCoin: 2,
  advancedTradingDesktop: 2,
  coinbaseOneFiat: 2,
  waitingForConsensus: 2,
  reviewAndAdd: 2,
  browserMultiPlatform: 4,
  finance: 2,
  crypto101: 3,
  walletPassword: 3,
  alerts: 2,
  coinbaseOneChat: 2,
  idVerification: 2,
  analyticsNavigation: 3,
  apartOfDropsNft: 2,
  transistor: 1,
  email: 5,
  hardwareWallet: 3,
  learningRewardsNavigation: 3,
  addressBook: 2,
  chat: 3,
  noAnnualFee: 2,
  tokenBaskets: 2,
  wallet: 2,
  increaseLimits: 1,
  authenticationApp: 2,
  formDownload: 1,
  securedAssets: 3,
  restaking: 2,
  clock: 2,
  derivativesNavigation: 3,
  coinbaseLogoNavigation: 2,
  walletLogoNavigation: 2,
  delegateNavigation: 3,
  accountsNavigation: 3,
  directDepositNavigation: 3,
  nftAvatar: 3,
  proNavigation: 3,
  walletLinkNavigation: 3,
  cloudNavigation: 3,
  participateNavigation: 3,
  apyInterest: 3,
  candleSticksGraph: 2,
  congratulations: 3,
  creative: 2,
  findYourSelection: 2,
  lightbulbLearn: 3,
  gasFees: 3,
  privateClientNavigation: 3,
  support: 3,
  assetHubNavigation: 3,
  positiveReviews: 2,
  cardDeclined: 2,
  nftLibrary: 2,
  earnNavigation: 4,
  getStarted: 3,
  assetMeasurements: 3,
  miningCoins: 2,
  coinFocus: 2,
  sendPaymentToOthers: 3,
  securityCoinShield: 3,
  stableCoinMetaphor: 3,
  borrowingLending: 2,
  calendarCaution: 2,
  stacking: 2,
  checkmark: 2,
  walletNavigation: 3,
  done: 2,
  envelope: 2,
  timingCheck: 3,
  gem: 2,
  notifications: 2,
  riskStaking: 2,
  trusted: 3,
  custodialJourney: 3,
  cryptoCard: 2,
  '2fa': 2,
  phone: 2,
  internet: 2,
  mintedNft: 1,
  addPhone: 2,
  laptopVideo: 2,
  key: 2,
  economyGlobal: 2,
  authenticator: 2,
  addToWatchlist: 2,
  googleAuthenticator: 2,
  passwordWalletLocked: 2,
  recurringPurchases: 1,
  stakingGraph: 3,
  typeScript: 2,
  fast: 2,
  noWiFi: 2,
  startToday: 2,
  barChart: 1,
  supportChat: 4,
  coinbaseOneTrusted: 3,
  learn: 3,
  bitcoinWhitePaper: 1,
  advancedTradingNavigation: 3,
  predictionMarkets: 2,
  earnCoins: 2,
  successPhone: 2,
  newUserChecklistCompleteAccount: 2,
  settings: 2,
  commerceInvoice: 2,
  selectAddNft: 1,
  shield: 3,
  commerceCheckout: 3,
  dataMarketplaceNavigation: 3,
  security: 2,
  defiEarnMoment: 2,
  dollarShowcase: 3,
  moreThanBitcoin: 2,
  contactInfo: 2,
  pizza: 2,
  wrapEth: 3,
  walletWarning: 3,
  creditCard: 2,
  coinbaseOneAuthenticator: 2,
  priceTracking: 2,
  higherLimits: 2,
  notificationHubPortfolio: 3,
  notificationHubAnalysis: 3,
  notificationHubNews: 4,
  notificationHubSocial: 1,
  driversLicenseWheel: 2,
  genericCountryIDCard: 2,
  walletError: 3,
  mobileError: 2,
  mobileWarning: 2,
  walletSuccess: 3,
  mobileSuccess: 2,
  cardSuccess: 2,
  myNumberCard: 3,
  advancedTradingRebates: 2,
  driversLicense: 2,
  ssnCard: 2,
  ethStaking: 2,
  faucetNavigation: 2,
  assetManagement: 2,
  primeMobileApp: 2,
  securityKey: 2,
  manageWeb3SignersAcct: 0,
  walletAsServiceNavigation: 4,
  planet: 3,
  baseLogoNavigation: 2,
  passport: 1,
  standWithCryptoLogoNavigation: 0
};
module.exports = versionMap;
//# sourceMappingURL=versionMap.js.map
